<template>
    <Button
        as="a"
        target="_blank"
        :href="
            urlFactory.makeGuestMeetingViewPageUrl(
                bookingData.booking.id,
                bookingData.getSingleExistingReservationData().reservation
                    .companyCustomerId,
            )
        "
        color="danger-outline"
        size="small"
        iconName="close-circle"
        iconClass="w-4 h-4"
        class="w-full lg:w-auto"
        :disabled="bookingData.cannotBeCanceled"
    >
        Cancel
    </Button>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import BookingData from '@/App/Booking/Booking/Entity/BookingData'

    const props = defineProps({
        bookingData: {
            type: Object as PropType<BookingData>,
            required: true,
        },
    })
    const urlFactory = new UrlFactory()
</script>
